var map = {
	"./close.svg": 8179,
	"./dis.svg": 1551,
	"./icon1.svg": 5363,
	"./text1.svg": 1805,
	"./tg.svg": 5602,
	"./title.svg": 129,
	"./x.svg": 7355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;